import { Injectable } from '@angular/core';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/route.entity';
import { PromiseLoad } from '@core/utils/promise-load';
import { NavigationItem } from '@shared/models/navigation-item';

export interface AppAgentConfig {
    theme?: string;
}

@Injectable({
    providedIn: 'root',
})
export class AppState {
    public theme: string;

    public readonly navigationItems: NavigationItem[] = [
        {
            id: 1,
            title: marker('route.printed-ticket'),
            url: [RouteEntity.Root, RouteEntity.PrintedTicket],
        },
        {
            id: 2,
            title: marker('route.top-up'),
            url: [RouteEntity.Root, RouteEntity.TopUp],
        },
        {
            id: 3,
            title: marker('route.sell-product'),
            url: [RouteEntity.Root, RouteEntity.SellProduct],
        },
        {
            id: 4,
            title: marker('route.sell-card'),
            url: [RouteEntity.Root, RouteEntity.SellCard],
        },
        {
            id: 5,
            title: marker('route.register-card'),
            url: [RouteEntity.Root, RouteEntity.RegistryCard],
        },
    ];

    public loadAppConfig(): void {
        new PromiseLoad('/app.config.json').get().then((config: AppAgentConfig) => {
            this.theme = config?.theme || 'woodlands';
            document.body.setAttribute('data-theme', this.theme);
        });
    }
}
